<style>
#attachmentsRegisterModal .v--modal-box.v--modal {
  min-height: 430px !important;
  min-width: 740px !important;
}
#attachmentsRegisterModal .modal__content {
  overflow-y: hidden !important;
}
#attachmentsRegisterModal .modal__footer {
  display: none;
}
</style>

<template>
  <Modal
    modalName="attachmentsRegisterModal"
    title="WYKAZ ZAŁĄCZNIKÓW"
    @opened="getAttachments"
    :buttons="[]"
    :register="register"
  >
    <AttachmentsTable />
  </Modal>
</template>

<script>
import Modal from "../../shared/Modal"
import AttachmentsTable from "../../viewer/table/attachments/AttachmentsTable";

export default {
  components: {
    Modal,
    AttachmentsTable
  },
  data: () => ({
    register: true
  }),
  methods: {
    getAttachments() {
      this.$store.dispatch("getAttachments").then(success => {
        if(success) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie pobrano załączniki"
          );
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania załączników wystąpił błąd"
          );
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/registers/AttachmentsRegister.vue